import React, { useState } from 'react'
import { GeneralTable } from 'modules/app/styles'
import { ReactComponent as EditIcon } from 'assets/images/icons/edit.svg'
import { ReactComponent as CopyLinkIcon } from 'assets/images/icons/copy_link.svg'
import { ReactComponent as SuccessIcon } from 'assets/images/icons/success.svg'
import { getEmail } from './index'
import { UncontrolledTooltip } from 'reactstrap'

export const Pending = (props) => {
  const [copiedId, set_coppiedId] = useState(null)
  const handleCopy = async (e, member) => {
    e.preventDefault()
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(`${process.env.REACT_APP_API_BASE_URL}invite-accept?invite_token=${member.invite_token}`)
      set_coppiedId(member.id)
      setTimeout(() => {
        set_coppiedId(null)
      }, 1200)
    } else {
    }
  }
  return (
    <GeneralTable responsive>
      <thead>
        <tr>
          {props.my_membership.user_type === 'admin' && <th style={{ width: 80 }}></th>}
          <th style={{ minWidth: 150 }}> Email </th>
        </tr>
      </thead>
      <tbody>
        {props.memberList.length === 0 && (
          <tr>
            <td colSpan={3}> No members. </td>
          </tr>
        )}
        {props.memberList.map((member, index) => {
          return (
            <tr key={index} id={`member_${member.id}`}>
              {props.my_membership.user_type === 'admin' && (
                <td>
                  <div className='action-buttons'>
                    <a href='/' id={`edit_${member.id}`} onClick={(e) => props.onShowEditMember(e, member)}>
                      <EditIcon />
                    </a>
                    <a href='/' className='ml-3' id={`copy_${member.id}`} onClick={(e) => handleCopy(e, member)}>
                      {copiedId !== member.id && <CopyLinkIcon />}
                      {copiedId === member.id && <SuccessIcon />}
                    </a>
                    <UncontrolledTooltip target={`copy_${member.id}`}>
                      {copiedId !== member.id && 'Copy invite link'}
                      {copiedId === member.id && 'Copied'}
                    </UncontrolledTooltip>
                    <UncontrolledTooltip target={`edit_${member.id}`}>Edit</UncontrolledTooltip>
                  </div>
                </td>
              )}
              <td>{getEmail(member)}</td>
            </tr>
          )
        })}
      </tbody>
    </GeneralTable>
  )
}
